"use client";

import React from "react";
import { Monitor, Warehouse, Globe } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const spaces = [{
  title: "Office",
  icon: Monitor,
  description: "Elite Phoenix workspaces. High-performance layouts. Found instantly."
}, {
  title: "Industrial",
  icon: Warehouse,
  description: "Strategic logistics hubs. Modern warehouse shells. Precision locations."
}, {
  title: "Any Space",
  icon: Globe,
  description: "Niche custom specs. AI-powered matching. Nationwide network."
}];
export default function Service() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="186178" id="office-industrial-any-space" className="bg-background py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={ref} className={`flex flex-col items-center space-y-16 transition-all duration-1000 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          <div className="max-w-3xl text-center">
            <h2 className="mb-4 font-sans text-4xl font-black uppercase tracking-tighter text-[#173153] md:text-6xl lg:text-7xl">
              Find the Right Space—<span className="text-primary">Faster</span>
            </h2>
            <p className="text-lg font-medium tracking-wide text-[#173153] md:text-xl">
              Tell PocketPal what you need—get connected fast.
            </p>
          </div>

          <div className="grid w-full grid-cols-1 gap-8 md:grid-cols-3">
            {spaces.map((space, i) => {
            const Icon = space.icon;
            return <Card key={i} data-index={i} className="group relative overflow-hidden rounded-none border border-primary/20 bg-[#173153] shadow-[0_0_20px_rgba(60,197,243,0.15)] transition-all duration-500 hover:-translate-y-[10px] hover:border-primary hover:shadow-[0_0_40px_rgba(60,197,243,0.25)]">
                  <CardHeader className="pb-4">
                    <Icon className="size-12 text-primary transition-transform duration-500 group-hover:scale-110" strokeWidth={2.5} />
                  </CardHeader>
                  <CardContent>
                    <CardTitle className="mb-3 font-sans text-3xl font-black uppercase tracking-tighter text-white">
                      {space.title}
                    </CardTitle>
                    <p className="text-sm font-medium leading-relaxed text-white">
                      {space.description}
                    </p>
                  </CardContent>
                </Card>;
          })}
          </div>

          <div className="text-center">
            <Button asChild size="lg" className="rounded-none bg-secondary px-10 py-8 text-xl font-black uppercase tracking-widest text-secondary-foreground shadow-[0_0_20px_rgba(252,178,49,0.4)] transition-all hover:bg-secondary/90 hover:shadow-[0_0_35px_rgba(252,178,49,0.6)]">
              <Link to="/PocketPalPage" className="inline-flex items-center justify-center gap-2 whitespace-nowrap [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive h-10 has-[>svg]:px-4 rounded-none bg-secondary px-10 py-8 text-xl font-black uppercase tracking-widest text-secondary-foreground shadow-[0_0_20px_rgba(252,178,49,0.4)] transition-all inline-flex items-center justify-center gap-2 whitespace-nowrap [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive h-10 has-[>svg]:px-4 rounded-none bg-secondary px-10 py-8 text-xl font-black uppercase tracking-widest shadow-[0_0_20px_rgba(252,178,49,0.4)] transition-all !text-[hsl(214,57%,21%)] !opacity-[1] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-secondary/90 hover:shadow-[0_0_35px_rgba(252,178,49,0.6)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-secondary/90 hover:shadow-[0_0_35px_rgba(252,178,49,0.6)]">TALK TO POCKETPAL</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}